import {
  AssignmentIcon,
  BadgeIcon,
  DescriptionIcon,
  EmojiEventsIcon,
  ExtensionIcon,
  SchoolIcon,
  SettingsIcon,
  ShieldCheckIcon,
} from '@orijinworks/frontend-commons';

/**
 * FolderNav props aligned with Figma Secondary tabs (19:9238). Icons must come from fe-commons
 * (see reentry FolderNav note) because FolderNav's `sx` color resolution needs fe-commons' MUI
 * theme context. Swap requested by Melissa on
 * https://www.figma.com/design/oZ41SABuVKQGuDYPhpW1Il (node 240:10877).
 */
export const SPLIT_MODULE_FOLDER_NAV_PROPS = {
  variant: 'tabs',
  color: 'var(--blue-main)',
  tabFontColor: {
    active: 'var(--blue-main)',
    inactive: 'var(--grey-20)',
    inactiveColor: 'var(--grey-110)',
  },
  inactiveTabBackground: 'var(--grey-20)',
  inactiveTabColor: 'var(--grey-110)',
  scrollButtons: false,
};

export const USER_MANAGEMENT_TAB_ICONS = {
  learners: SchoolIcon,
  staff: BadgeIcon,
  certificates: EmojiEventsIcon,
  resumes: DescriptionIcon,
};

export const LOCATION_MANAGEMENT_TAB_ICONS = {
  settings: SettingsIcon,
  forms: AssignmentIcon,
  services: ExtensionIcon,
  'biometric-authentication': ShieldCheckIcon,
};
